import { useMutation } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { makeAPIRequestReactQueryWithHeaders } from '../api';
import { getAccessToken } from '@/utils/api';

import { endpoints } from '../endpoints';

export interface AddSuggestedValueResponse {
  suggestedValues: string[];
}

export const useAddSuggestedValue = () => {
  const { primaryPracticeId: practiceId, primaryOrganizationId: orgId } =
    useSelector(
      (state: {
        login: {
          user: { primaryPracticeId?: string; primaryOrganizationId?: string };
        };
      }) => state.login.user,
    );

  return useMutation({
    mutationFn: async ({
      fieldKey,
      value,
    }: {
      fieldKey: string;
      value: string;
    }) => {
      const token = getAccessToken();
      return makeAPIRequestReactQueryWithHeaders<AddSuggestedValueResponse>(
        `/${endpoints.ambient.voiceNotes.suggestedValues(fieldKey)}`,
        {},
        {
          practice: practiceId,
          org: orgId,
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        'POST',
        {
          data: { value: value.trim() },
        },
      );
    },
  });
};
